import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";
import { useHashtagStore } from "%/dynamic-component-editor/stores/hashtag-store";

const EMPTY_HASHTAG_ENTITY = Object.freeze({
  hashtagId: 0,
  hashtag: "",
  followerCount: 0,
  isFollowing: false,
});

// Routes Hashtag* elements through the hashtag-store so production
// reads the URL-derived hashtag slug (via pageEntities.storiesWithHashtag)
// and lazy-fetches the hashtag entity (`hashtag` here is a string slug,
// not an integer id).
export const StoriesWithHashtagPageElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  inject: {
    pageEntities: { default: null },
    useExampleData: { default: () => () => false },
  },
  entityStore: () => useHashtagStore(),
  created() {
    if (this.editMode || this.isPreviewMode) {
      return;
    }
    const id = this.hashtagEntityId;
    if (!id) {
      return;
    }
    useHashtagStore().getOrFetchHashtag(id);
  },
  computed: {
    isPreviewMode() {
      const fn = this.useExampleData;
      return typeof fn === "function" ? Boolean(fn()) : Boolean(fn);
    },
    hashtagEntityId() {
      const fromPage = typeof this.pageEntities === "function" ? this.pageEntities()?.storiesWithHashtag : this.pageEntities?.storiesWithHashtag;
      return fromPage ?? "";
    },
  },
  methods: {
    getExampleEntity() {
      return {
        hashtagId: 1,
        hashtag: "inspiration",
        followerCount: 12_408,
        isFollowing: false,
      };
    },
    getRealEntity() {
      if (this.isPreviewMode) {
        return this.getExampleEntity();
      }
      const id = this.hashtagEntityId;
      if (!id) {
        return EMPTY_HASHTAG_ENTITY;
      }
      const cached = useHashtagStore().hashtags?.[id];
      if (cached && cached.hashtag) {
        return cached;
      }
      return EMPTY_HASHTAG_ENTITY;
    },
  },
};
